// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import VueRouter from 'vue-router'
import VueProgressBar from 'vue-progressbar'
import moment from 'moment'

import ErrorPage from '@/components/404'

import Dashboard from '@/pages/Dashboard'
import SyncedUsers from '@/pages/SyncedUsers'
import Membership from '@/pages/Membership'
import LoggingExport from '@/pages/LoggingExport'
import LawGuideEdit from '@/pages/LawGuideEdit'

import Login from '@/components/Login'
import Search from '@/pages/Search'
import ChangePassword from '@/components/ChangePassword'


import DocumentList from '@/pages/DocumentList'
import PermissionDenied from '@/pages/PermissionDenied'

import DocumentEditForm from '@/pages/DocumentEditForm'
import ViewDocument from '@/pages/ViewDocument'
import metadata from './metadata.json';

import feathers from '@feathersjs/client';

const htmlToText = require('html-to-text');

const feathersApp = feathers()


const auth = feathers.authentication
const rest = feathers.rest
var restClient = rest('https://search.mnmsba.org/api')

if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    //restClient = rest('http://localhost:5000')  // Localhost only devv

    restClient = rest('http://localhost:5000')
}

function buildSearchableText(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const textContent = doc.body.textContent || "";
    // Remove extra line breaks
    return textContent.replace(/\n\s*\n/g, '\n');
}

function getCookie(name) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let [k,v] = el.split('=');
        cookie[k.trim()] = v;
    })
    return cookie[name];
}

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    console.log('Query variable %s not found', variable);
}
var token =  window.localStorage.getItem('feathers-jwt');
var urlToken = window.location.hash.replace('#access_token=','')

if (token == null || token == undefined) {
    console.log('no localstorage or blocked')
    let cookieVal = getCookie('feathers-jwt')
    console.log('trying cookie', cookieVal)
    token = cookieVal
}

console.log('token get result is', token)

  if (urlToken != "" && urlToken != null)  {
     console.log("got token from url....", urlToken)
     token = urlToken
     window.localStorage.setItem('feathers-jwt', token);
     console.log('set token', token)
 } else if (token != "" && token != null) {
    console.log("got token from cookie....", urlToken)
} else {
     console.log('auth failure!!!!!! NO TOKEN')
     /* if(window.location.pathname != "/auth")
      window.location.replace("http://localhost:5000/oauth/wordpress/");

      */
 }




feathersApp.configure(restClient.fetch(window.fetch));

/*feathersApp.configure(auth({
    storage: window.localStorage
}))*/

feathersApp.configure(feathers.authentication({
        cookie: 'feathers-jwt'
    }))


feathersApp.service("auth");
feathersApp.service("policies");
feathersApp.service("publications");
feathersApp.service("resources");
feathersApp.service("servicemanuals");
feathersApp.service("resourcelibrary");
feathersApp.service("journalarchives");
feathersApp.service("leaderarchives");
feathersApp.service("weeklyadvocatearchives");
feathersApp.service("eclippingsarchives");
feathersApp.service("lawguidestructure");
feathersApp.service("logging");
feathersApp.service("logexport");

feathersApp.service("schemas");


const vueFeathers = require('vue-feathers')

import TextHighlight from 'vue-text-highlight';

Vue.component('text-highlight', TextHighlight);

// And plug it in
Vue.use(vueFeathers, feathersApp)
Vue.use(VueRouter)



// Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';
// Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)



const options = {
    color: '#2196f3',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.1s',
        opacity: '0.5s',
        termination: 400
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

Vue.use(VueProgressBar, options)

Vue.use(Vuetify)
Vue.config.productionTip = false

let globalData = new Vue({
    data: {
        $version: metadata.buildRevision + " - " + metadata.buildTag, // Project version
        $endpoints: [],
        $pagination:{"policy" : 1},
        $schemas: {},
        $userData: {},
        $webpages: [],
        $policies: [],
        $resourcelibrary: {},
        $servicemanuals: [],
        $publications: [],
        $resources: [],
        $eclippingsarchives:[],
        $weeklyadvocatearchives:[],
        $leaderarchives: [],
        $journalarchives: [],
        $lawguidestructure: [],
        $membershipRoles: [],
        $dataLoaded: false,
        $documentTypes: [
            {title: "Policies", id: 'policies'},
            {title: "School Law", id: 'serviceManuals'},
            {title: "Publications", id: 'publications'},
            {title: "Resources", id: 'resources'},
            {title: "Website", id: 'website'}],
        $resourceTypes: ["Form", "Resolution", "Model Agreement", "Informational Resource", "Sample Document"],
        $publicationTypes: ["Leader", "Journal", "Weekly Advocate", "MSBA Advocate"],
        $revisionTypes: [{title: "Statute", id: 'S'}, {title: "Law", id: 'L'}, {title: "Rule", id: 'R'}],
        $policyTypes: [{title: "Mandatory", id: 'M'}, {title: "Legislative", id: 'L'}, {title: "Recommended", id: 'R'}],
    }
});

function redirectToLogin() {
    //window.location.replace("https://dev1.mnmsba.org/login?redirectTo=" + window.location.href);

    console.log('in redirectToLogin')

    try {
        top.location.replace("https://mnmsba.org/logout?redirectTo=" + top.location.href);
    } catch (error) {
        console.log('callin parent ')
        let message = JSON.stringify({
            event: 'logout'
        });
        window.parent.postMessage(message, '*');
    }




    // window.location.replace("https://mnmsba.org/login?redirectTo=" + window.location.href);
}

function doLogin() {

    let loginErr = null
    console.log('FEATHERJSAPP AUTHENTICATE')

    return feathersApp.authenticate({ strategy: 'jwt', accessToken: token })
        .then(response => {
            console.log('Authenticated in main!', response);
            feathersApp.set('userData', response.user);
            return feathersApp.passport.verifyJWT(response.accessToken);
        })
        .then(user => {
            console.log('User logged in...... in main', user);
            feathersApp.set('user', user);
        })
        .catch(function(error){
            console.log('Error authenticating!!!!!!!!!!!! in main', error);
            loginErr = error

            var token =  window.localStorage.getItem('feathers-jwt');
            if (token == null || token == undefined) {
                console.log('no localstorage or blocked')
                let cookieVal = getCookie('feathers-jwt')
                console.log('trying cookie', cookieVal)
                token = cookieVal
            }
            if(token != "" && token != null) {
                console.log('looks like expired token. removing token cookies')
                window.localStorage.removeItem('feathers-jwt')
                document.cookie = "feathers-jwt= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"

               // redirectToLogin()

                
              //  window.location = "https://mnmsba.org/login2?redirect=" + window.location
            }
            if(location.host == "search.mnmsba.org") {
             //   location.replace("https://search.mnmsba.org/api/oauth/wordpress/");
             //   alert('Under development - You are not logged into wordpress. You will be redirect to login.')
            }
        }).finally(function(){

            let message = {
                event: 'authresult'
            };

            if(loginErr === null) {
                message.user = feathersApp.get('userData')
            } else {
                message.error = loginErr.message
            }

            window.parent.postMessage(JSON.stringify(message), '*');
        })
}

function iterateSchooLaw(data){
    data.forEach((data)=>{
        if(data.hasOwnProperty('children') ) {
            iterateSchooLaw(data.children)
        } else {
        }
    })
}


Vue.mixin({
    methods: {
        $login() {
            return doLogin()
        },
        $error(err) {
            console.log('gotten an error', err)
            alert('An error occured: \n\n' + err)
        },
        $checkUserdata() {
           return this.$feathers.get('userData')
        },
        $getFeatherEndpoint(doc) {
            let endPoints = {
                policy: "policies",
                publication: "publications",
                resource: "resources",
                servicemanual: "servicemanuals",
                "school law": "servicemanuals",
                leaderarchive: "leaderarchives",
                journalarchive: "journalarchives",
                weeklyadvocatearchive: "weeklyadvocatearchives",
                eclippingsarchive: "eclippingsarchives"
            }
            return endPoints[doc.docType.toLowerCase()];

        },
        $deleteMultipleDocument(docTypeObj, documents, index=0) {
            let serverType = this.$getFeatherEndpoint(docTypeObj)
            console.log('$deleteMultipleDocument', index)
            return this.$services[serverType].remove(documents[index].id).then((result) => {
                console.log('doc delete result', result)
                for (let i = globalData.$data['$' + serverType].length - 1; i >= 0; --i) {
                    if (globalData.$data['$' + serverType][i].id === documents[index].id) {
                        globalData.$data['$' + serverType].splice(i, 1);
                    }
                }
                if(index + 1 < documents.length) {
                    return this.$deleteMultipleDocument(docTypeObj, documents, index + 1)
                } else {
                    this.$emit("alertUser", "success", "Deleted " + documents.length + " documents ")
                }
            }).catch((error)=>{
                this.$emit("alertUser", "error", "Aborting because error: " + error)
                console.log('error', error)
            })



        },
        $deleteDocument(doc) {
            let serverType = this.$getFeatherEndpoint(doc)
            console.log('in delete document', doc, serverType)
            this.$services[serverType].remove(doc.id).then((result) => {
                console.log('doc delete result', result)
                for (let i = globalData.$data['$' + serverType].length - 1; i >= 0; --i) {
                    if (globalData.$data['$' + serverType][i].id === doc.id) {
                        globalData.$data['$' + serverType].splice(i, 1);
                    }
                }
                this.$emit("alertUser", "success", "Deleted document " + doc.id)
            }).catch((error)=>{
                    this.$emit("alertUser", "error", "Error: " + error)
                    console.log('error', error)
                })
        },
        addTitleToLawGuideRef(doc) {
            if(doc.id == undefined)
                return doc
            let serviceManual = globalData.$data.$servicemanuals.find((x)=>x.id == doc.id)
            if(serviceManual != null) {
                doc.title = serviceManual.revnumber + ' - ' + serviceManual.description
            }
            return doc
        },
        $getLogs() {
            //return this.$services['logging'].find()
            return this.$services['logging'].find({
            });
        },
        $exportLogs(){
            console.log('in export logs')
            return this.$services['logexport'].get(1);
        },
        $sendMessageToParent(eventType, eventData = {}) {
            console.log('$sendMessageToParent', eventType, eventData)
            let message = JSON.stringify({
                event: eventType,
                data: eventData
            });
            window.parent.postMessage(message, 'https://mnmsba.org/');
        },
        $sendLogEntry(entry){
            console.log('in $sendLogEntry', entry)
            return this.$services['logging'].create(entry)
        },
        $saveLawGuideChapter(chapter, data) {
            var realThis = this
           let rowID = globalData.$data.$lawguidestructure.find((x)=>x.id == chapter)

            data.forEach(function(part, index, result){
                part.children.forEach(function(part, index, result){
                    if(part.hasOwnProperty('children') ) {
                        part.children.forEach(function(part, index, result){
                            result[index] = realThis.addTitleToLawGuideRef(part)


                        })
                    } else {
                        result[index] = realThis.addTitleToLawGuideRef(part)
                    }
                })

            })

            if(rowID == undefined) {
                return this.$services['lawguidestructure'].create({
                    id: chapter,
                    jsonData: JSON.stringify(data)
                }).then((result) => {
                    console.log('doc create result', result)
                    globalData.$data.$lawguidestructure.push(result)
                    this.$emit("alertUser", "success", "Updated ")
                }).catch((error)=>{
                    this.$emit("alertUser", "error", "Error: " + error)
                    console.log('error', error)
                })
            } else {
                return this.$services['lawguidestructure'].patch(chapter, {
                    jsonData: JSON.stringify(data)
                }).then((result) => {
                    console.log('doc patch result', result)
                    globalData.$data.$lawguidestructure.find((x)=>x.id == result.id).jsonData = result.jsonData
                    this.$emit("alertUser", "success", "Updated ")
                }).catch((error)=>{
                    this.$emit("alertUser", "error", "Error: " + error)
                    console.log('error', error)
                })
            }
        },
        compareJSON(a, b) {
            if (a == b) {
                return true
            }
            let aJSON = null
            let bJSON = null
            try {
                aJSON = JSON.parse(a);
            } catch (e) {
            }
            try {
                bJSON = JSON.parse(b);
            } catch (e) {
            }
            if(a == bJSON) {
                return true
            } else if (b == aJSON) {
                return true
            }

            return false

        },
        checkSavedVLocal(local, remote, saveType) {
            let equals = true
            let skipKeys = ['id','docType', 'searchcontent', 'featuredArticles', 'createdAt', 'updatedAt']

            console.log('comparing local v remote...local:', local)
            console.log('comparing local v remote...remote:',  remote)

            for (var key of Object.keys(local)) {
                if (!key.includes('pretty') && !skipKeys.includes(key) &&  remote[key] != undefined && local[key] != undefined && local[key] != '' && local[key] != remote[key]) {
                    equals = false
                    console.log('local v remote mismatch ' + key, local[key], remote[key])
                    this.$emit("alertUser", "warning", "Updated... However a field may not have been saved correctly. Please check: " + key)

                    return {
                        'check' : 'fail',
                        'mismatch' : key,
                        'remoteDoc' : remote
                    }

                }
            }

            if (equals) {
                this.$emit("alertUser", "success", saveType + " " + this.$prettyDocType(local.docType))
                this.$router.go(-1)
                return true
            }

        },
        $saveDocument(doc, dontRedirect=false) {
            let serverType = this.$getFeatherEndpoint(doc)
            console.log('in create/update doc', serverType, doc)
           if(doc.id != undefined) {
                return this.$services[serverType].patch(doc.id, doc).then((result) => {
                    console.log('doc patch result', result)
                    return this.checkSavedVLocal(doc, result, 'Updated')
                }).catch((error)=>{
                    this.$emit("alertUser", "error", "Error: " + error)
                    console.log('error', error)
                })
            } else {
                return this.$services[serverType].create(doc).then((result) => {
                    console.log('doc create result', result)

                    if(result.featuredArticles != null && result.featuredArticles.length >1)
                    result.featuredArticles = JSON.parse(result.featuredArticles)
                    globalData.$data['$' + serverType].unshift(result)
                   /* globalData.$data['$' + serverType]
                        .splice(globalData.$data.$policies
                            .findIndex(document => document === doc), 1);*/

                    console.log('GLOBAL DATA IS NOW ' + serverType, globalData.$data['$' + serverType])
                    return this.checkSavedVLocal(doc, result, 'Created')
                }).catch((error)=>{
                    this.$emit("alertUser", "error", "Error: " + error)
                    console.log('error', error)
                })
            }

        },
        $fetchData() {
            this.$services.schemas.find({
            }).then((result) => {
                console.log('schema result', result)
                globalData.$data.$endpoints = result.services
                globalData.$data.$schemas = result.models
            }).then(()=>{
                console.log('looping through endpoints')
                let totalCount = 0
                let requestsProcessed = 0
                var dataFetchStart = performance.now()
                this.$endpoints.forEach (async service => {
                    console.log('fetching ', service)

                    this.$services[service].find({
                    }).then((result) => {
                        requestsProcessed++
                        totalCount = totalCount + result.length
                        if(service == 'resourcelibrary') {
                            globalData.$data.$resourcelibrary = {
                                "schema" : result[0],
                                "data" : result[1]
                            }
                        } else if (service == 'leaderarchives' || service == 'journalarchives') {
                            result.map(item => {
                                var temp = Object.assign({}, item);
                                item.featuredArticles = JSON.parse(item.featuredArticles)
                                return item;
                            });
                            globalData.$data['$' + service] = result

                        }
                        else if (service == 'publications') {

                            globalData.$data['$' + service] = result
                            console.log('calling fetchWordpressLeaders')
                            this.fetchWordpressLeaders()


                        }
                        else {
                            globalData.$data['$' + service] = result

                        }


                        console.log('result for ' + service, result)

                        if(requestsProcessed == this.$endpoints.length) {
                            let dataFetchEnd = performance.now()
                            this.$dataLoaded = true
                            this.$emit("alertUser", "success",
                                "Fetched " + totalCount + " documents in " + ((dataFetchEnd - dataFetchStart )/1000).toFixed(2) + " seconds",
                                10000)
                        }

                    })
                })
            })

            this.fetchWebpages()

        },
        $prettyDocType(docType, isCharter){
            if(docType == 'policy') {
                if(isCharter == 1) {
                    docType = 'Charter Policy'
                } else {
                    docType = 'ISD Policy'
                }
            }

            let docTypes = {
                "weeklyadvocatearchive":"Weekly Advocate Archive",
                "leaderarchive":"Leader Archive",
                "journalarchive":"Journal Archive",
                "eclippingsarchive":"eClipping Archive"
            }
            return (docTypes[docType] ? docTypes[docType]  : docType)
        },
        fetchWebpages() {
            console.log('fetching webpages')
            return fetch("https://mnmsba.org//wp-json/wp/v2/pages?per_page=100")
                .then(response => response.text())
                .then((result) => {
                    var resultParsed = JSON.parse( result.substring(result.indexOf("[{")))
                    console.log('webpages fetch result',resultParsed)
                    globalData.$data.$webpages = resultParsed
                })
        },
        fetchWordpressLeaders() {
            console.log('fetching fetchWordpressLeaderArchives')
            return fetch("https://mnmsba.org//wp-json/wp/v2/leader_newsletter?per_page=100")
                .then(response => response.text())
                .then((result) => {
                    var resultParsed = JSON.parse( result.substring(result.indexOf("[{")))
                    console.log('fetchWordpressLeaderArchives fetch result',resultParsed)

                    globalData.$data.$publications = globalData.$data.$publications.concat(resultParsed.map(o => {
                        return {
                            id: o.id,
                            body: o.content.rendered,
                            keywords: "test",
                            title: o.title.rendered,
                            type: "Leader",
                            dateof: o.date.split('T')[0],
                            author: "MSBA",
                            searchcontent: buildSearchableText(o.content.rendered),
                            files: null,
                            link: o.link,
                            webcat: null,
                            websubcat: null,
                            status: null,
                            publicvisible: 0,
                            docType: "publication",
                            titleToUse: o.title.rendered
                        }
                    }))

                    console.log('globalData.$data.$publications',globalData.$data.$publications)

                })
        },
        $getDocument(id, docType=null) {
            console.log('in $getDocument', id, docType)
            var result = globalData.$data.$policies.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'policy'
                return result[0]
            }

            result = globalData.$data.$publications.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'publication'
                return result[0]
            }

            result = globalData.$data.$resources.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'resource'
                return result[0]
            }

            result = globalData.$data.$servicemanuals.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'school law'
                return result[0]
            }

            result = globalData.$data.$leaderarchives.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'leaderarchive'
                return result[0]
            }

            result = globalData.$data.$weeklyadvocatearchives.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'weeklyadvocatearchive'
                return result[0]
            }

            result = globalData.$data.$eclippingsarchives.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'eclippingsarchive'
                return result[0]
            }

            result = globalData.$data.$journalarchives.filter(obj => {
                return obj.id === id
            })
            if (result.length > 0) {
                result[0].docType = 'journalarchive'
                return result[0]
            }

        }
    },
    computed: {
        $pagination: {
            get: function () { return globalData.$data.$pagination },
            set: function (data) { globalData.$data.$pagination = data; }
        },
        $dataLoaded: {
            get: function () { return globalData.$data.$dataLoaded },
            set: function (data) { globalData.$data.$dataLoaded = data; }
        },
        $schemas: {
            get: function () { return globalData.$data.$schemas },
            set: function (data) { globalData.$data.$schemas = data; }
        },
        $version: {
            get: function () { return globalData.$data.$version },
            set: function (data) { globalData.$data.$version = data; }
        },
        $endpoints: {
            get: function () { return globalData.$data.$endpoints },
            set: function (data) { globalData.$data.$endpoints = data; }
        },
        $journalArchives: {
            get: function () { return globalData.$data.$journalarchives },
            set: function (data) { globalData.$data.$journalarchives = data; }
        },
        $lawguidestructure: {
            get: function () { return globalData.$data.$lawguidestructure },
            set: function (data) { globalData.$data.$lawguidestructure = data; }
        },
        $eclippingsArchives: {
            get: function () { return globalData.$data.$eclippingsarchives },
            set: function (data) { globalData.$data.$eclippingsarchives = data; }
        },
        $weeklyAdvocateArchives: {
            get: function () { return globalData.$data.$weeklyadvocatearchives },
            set: function (data) { globalData.$data.$weeklyadvocatearchives = data; }
        },
        $leaderArchives: {
            get: function () { return globalData.$data.$leaderarchives },
            set: function (data) { globalData.$data.$leaderarchives = data; }
        },
        $resourceLibrary: {
            get: function () { return globalData.$data.$resourcelibrary },
            set: function (data) { globalData.$data.$resourcelibrary = data; }
        },
        $documentTypes: {
            get: function () { return globalData.$data.$documentTypes },
            set: function (data) { globalData.$data.$documentTypes = data; }
        },
        $resourceTypes: {
            get: function () { return globalData.$data.$resourceTypes },
            set: function (data) { globalData.$data.$resourceTypes = data; }
        },
        $revisionTypes: {
            get: function () { return globalData.$data.$revisionTypes },
            set: function (data) { globalData.$data.$revisionTypes = data; }
        },
        $policyTypes: {
            get: function () { return globalData.$data.$policyTypes },
            set: function (data) { globalData.$data.$policyTypes = data; }
        },
        $publicationTypes: {
            get: function () { return globalData.$data.$publicationTypes },
            set: function (data) { globalData.$data.$publicationTypes = data; }
        },
        $userData: {
            get: function () { return globalData.$data.$userData },
            set: function (data) { globalData.$data.$userData = data; }
        },
        $membershipRoles: {
            get: function () { return globalData.$data.$membershipRoles },
            set: function (data) { globalData.$data.$membershipRoles = data; }
        },
        $webpages: {
            get: function () {
                var toReturn = []
                globalData.$data.$webpages.forEach((webpage)=>{
                    toReturn.push({
                        "title": webpage.title.rendered,
                        "searchcontent": "test",
                        "link": webpage.link
                    })
                })
                return toReturn
            }
        },
        $policies: {
            get: function () {
                return globalData.$data.$policies
            }
        },

        $serviceManuals: {
            get: function () {
                return globalData.$data.$servicemanuals
            }
        },
        $publications: {
            get: function () {
                return globalData.$data.$publications
            }
        },
        $resources: {
            get: function () {
                return globalData.$data.$resources
            }
        }

    },
})

function requireAuth (to, from, next) {
    console.log('this app userdata', globalData.$data.$userData)
    if (globalData.$data.$userData.permissions === undefined) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
    } else {
        next()
    }
}

function test (to, from, next) {
    console.log('test before route', to, from, next)
}


const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        { path: '/404', component: ErrorPage, name: 'ErrorPage' },
        { path: '/search', component: Search, name: 'Search' },
        { path: '/doc/:type/:id', component: ViewDocument, name: 'ViewDocument' },
        { path: '/search/:id', component: Search, name: 'Search' },
        { path: '/dashboard', component: Dashboard, name: 'Dashboard', beforeEnter: requireAuth },
        { path: '/syncedusers', component: SyncedUsers, name: 'SyncedUsers', beforeEnter: requireAuth },
        { path: '/membership', component: Membership, name: 'Membership', beforeEnter: requireAuth },
        { path: '/loggingexport', component: LoggingExport, name: 'LoggingExport', beforeEnter: requireAuth},
        { path: '/lawguide', component: LawGuideEdit, name: 'LawGuideEdit'},

        { path: '/denied', component: PermissionDenied, name: 'PermissionDenied'},
        { path: '/documents/:type', name: 'Documents', component: DocumentList, beforeEnter: requireAuth },
        { path: '/edit/:type/:id', component: DocumentEditForm, name: 'EditDocument', beforeEnter: requireAuth },
        { path: '/new/:type', component: DocumentEditForm, name: 'NewDocument', beforeEnter: requireAuth },
        { path: '/login/:id', component: Login, name: 'Login' },
        { path: '/login', component: Login, name: 'Login' },
        { path: '/changePassword', component: ChangePassword, name: 'ChangePassword' },
        { path: '/logout',
            beforeEnter (to, from, next) {
                // auth.logout()
                next('/login')
            }
        },
        { path: '/', redirect: '/dashboard', beforeEnter: test },
        { path: '*', redirect: '/404', beforeEnter: test }
    ],
    meta: {
        progress: {
            func: [
                {call: 'color', modifier: 'temp', argument: '#ffb000'},
                {call: 'fail', modifier: 'temp', argument: '#6e0000'},
                {call: 'location', modifier: 'temp', argument: 'top'},
                {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
            ]
        }
    }
})

/* eslint-disable no-new */

/*
console.log('!!!!!! BEFORE AUTH!!!!!!!!!!', token)

feathersApp.authenticate({ strategy: 'jwt', accessToken: token })
    .then(response => {
        console.info('Feathers Client has Authenticated with the JWT access token!');
        console.log(response);
    })
    .catch(error => {
        window.location.replace("http://localhost:5000/oauth/wordpress/");
    });

*/

console.log('FEATHERJSAPP AUTHENTICATE')



doLogin().finally(() => {
        console.log('FINALLY! in main')

        new Vue({
            el: '#app',
            router,
            render: h => h(App)
            // template: '<App/>',
            // components: { App }
        })
    })




